import { render, staticRenderFns } from "./AutomationSMSContentTemplate.vue?vue&type=template&id=79827b49&"
import script from "./AutomationSMSContentTemplate.vue?vue&type=script&lang=js&"
export * from "./AutomationSMSContentTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports